var exports = {
  "nb": "issueLinkAnchor____eFj5",
  "ts": "issueTitleContainer__KSCB0A",
  "JK": "repoIssueNumber__kRDwzG",
  "jc": "issueContainer__qJtLfi",
  "p4": "inlineIcon__ruwEDg",
  "nW": "blockIcon___3gklG",
};

module.exports = exports;
